import { deferScript } from '@confluence/dom-helpers';
import { fg } from '@confluence/feature-gating';
import { expVal } from '@confluence/feature-experiments';

import { ResourceRecorder } from './ResourceRecorder';

export class SuperbatchResourceRecorder extends ResourceRecorder {
	private includeSuperBatch: boolean;
	private includeConnect: boolean;
	private connectResource: string;
	private isJS: boolean;

	constructor(isJS: boolean) {
		super();
		this.includeConnect = false;
		this.connectResource = '';
		this.isJS = isJS;
		this.includeSuperBatch = false;
	}

	reset() {
		super.reset();
		this.includeSuperBatch = false;
		this.includeConnect = false;
		this.connectResource = '';
	}

	includeSuperBatchResources() {
		this.includeSuperBatch = true;
	}

	includeConnectWebResources() {
		// Connect web resources always need superbatch, so we need to include both if we're including connect
		this.includeSuperBatchResources();
		this.includeConnect = true;
	}

	get() {
		if (!this.includeSuperBatch) return '';
		if (!this.isJS) return this.resource;

		return this.includeConnect &&
			(fg('content_early_connect_iframe_initialization') ||
				expVal('confluence_frontend_early_webpanel_initialization', 'isEnabled', false))
			? this.resource
			: deferScript(this.resource);
	}

	addConnectResource(connectResource: string) {
		// Ensure that we include connect web resources in the response if they're detected
		if (
			!this.includeConnect &&
			window?.__SSR_REACT_STREAMING__ &&
			(fg('content_early_connect_iframe_initialization') ||
				expVal('confluence_frontend_early_webpanel_initialization', 'isEnabled', false))
		) {
			this.includeConnectWebResources();
		}

		if (this.connectResource) {
			this.connectResource += '\n';
		}
		this.connectResource += connectResource;
	}

	getConnect() {
		// connect always need superbatch.
		return !!this.get() &&
			this.includeConnect &&
			(fg('content_early_connect_iframe_initialization') ||
				expVal('confluence_frontend_early_webpanel_initialization', 'isEnabled', false))
			? this.connectResource
			: '';
	}
}
